import Badge from "@mui/material/Badge";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import FilterListIcon from "@mui/icons-material/FilterList";
import { JobListTemplate } from "./JobListTemplate";

interface JobListHeaderProps {
  isFilterActive: boolean;
  onFilterToggle: () => void;
}

const HEADINGS: [string, string, "left" | "right"][] = [
  ["job", "JOB", "left"],
  ["subject", "FOR", "left"],
  ["trigger", "STARTED BY", "left"],
  ["status", "STATUS", "left"],
  ["started", "STARTED", "left"],
  ["duration", "TOOK", "right"],
  ["summary", "RESULT", "left"],
];

/** The Jobs list's column headings, with the filter toggle in the expand column (a dot when a filter is applied). */
export const JobListHeader = (props: JobListHeaderProps) => {
  const { isFilterActive, onFilterToggle } = props;

  return (
    <JobListTemplate sx={{ pb: 1.5 }}>
      <IconButton
        aria-label="Filter jobs"
        onClick={onFilterToggle}
        size="small"
        sx={{
          gridArea: "expand",
          my: -0.5,
        }}
      >
        <Badge
          color="primary"
          invisible={!isFilterActive}
          variant="dot"
        >
          <FilterListIcon fontSize="small" />
        </Badge>
      </IconButton>
      {HEADINGS.map(([area, label, align]) => (
        <Typography
          key={area}
          noWrap
          sx={{
            gridArea: area,
            textAlign: align,
          }}
          variant="subtitle2"
        >
          {label}
        </Typography>
      ))}
    </JobListTemplate>
  );
};
